import { Link } from 'react-router-dom';
import type { Game } from '@/types';

export default function GameCard({ game }: { game: Game }) {
  return (
    <Link
      to={`/category/${game.category}`}
      className="group block bg-background-100 rounded-lg overflow-hidden border border-background-300/30 hover:border-primary-500/30 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={game.image}
          alt={game.title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50/90 via-transparent to-transparent"></div>
        <div className="absolute top-2 left-2 flex items-center gap-1.5">
          <span className="px-2 py-0.5 bg-primary-500/90 text-background-50 text-xs rounded-md font-medium">
            {game.categoryName}
          </span>
        </div>
        <div className="absolute top-2 right-2 flex items-center gap-1 bg-background-50/80 backdrop-blur-sm px-2 py-0.5 rounded-md">
          <i className="ri-star-fill text-accent-500 text-xs"></i>
          <span className="text-xs font-medium text-foreground-900">{game.rating}</span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <h3 className="text-sm font-medium text-foreground-50 line-clamp-1">{game.title}</h3>
          <div className="flex items-center gap-2 mt-1.5">
            {game.platform.map((p) => (
              <span key={p} className="text-xs text-foreground-300 bg-background-50/30 px-1.5 py-0.5 rounded">
                {p}
              </span>
            ))}
            <span className="text-xs text-foreground-400 ml-auto flex items-center gap-1">
              <i className="ri-download-line"></i>
              {game.downloads > 10000 ? `${(game.downloads / 10000).toFixed(1)}万` : game.downloads}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}